import * as React from 'react';

var AtomSectionContext = React.createContext({});
var AtomSectionContextProvider = AtomSectionContext.Provider;

export { AtomSectionContext, AtomSectionContextProvider, AtomSectionContext as default };
//# sourceMappingURL=AtomSectionContext.esm.js.map
